var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('app-loading',{staticStyle:{"z-index":"999"}}),_c('app-modal'),_c('app-snackbar'),(_vm.layout)?_c(_vm.layout,{tag:"component"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }